import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[stop-propa]'
})

export class StopPropaClickDirective {

  constructor() { }
  
  @HostListener("click", ["$event"])
  public onClick(event: any): void
  {
    event.stopPropagation();
  }
  

}
